<template>
  <main-layout>
    <router-view :key="$route.fullPath" />
  </main-layout>
</template>
<script>
/**
 * ==================================================================================
 * Transaction layout
 * ==================================================================================
 **/

import MainLayout from '@/layouts/MainLayout'

export default {
  components: {
    MainLayout
  }
}
</script>
